import { createAction } from '@reduxjs/toolkit'
import { TagDetail } from 'sierra-domain/api/admin'

export const addTagAction = createAction<TagDetail>('skill/add')
